
/**
 * adds url field to all companies in all questions.
 */
export function addCompanyUrlsInPlace(questions) {
  for (const q of questions) {
    if (!Array.isArray(q.companies)) {
      q.companies = [];
      continue;
    }
    for (const c of q.companies) {
      c.url = c?.code ? `/lld/${c.code}` : "#";
    }
  }
  return questions;
}

/**  - util: order companies by search query, preserving original order ---
 * - move companies which contain the query ahead
 * - This method doesn't changes original array
 */
export function orderCompaniesByQuery(companies = [], q = "") {
  const query = (q ?? "").toString().trim().toLowerCase();
  if (!query) return companies;

  const score = (c) => {
    const name = (c?.name ?? "").toLowerCase();
    const code = (c?.code ?? "").toLowerCase();
    if (name.startsWith(query) || code.startsWith(query)) return 0; // best
    if (name.includes(query) || code.includes(query)) return 1;      // good
    return 2;                                                        // no match
  };

  // stable sort via original index as tie-breaker
  return companies
    .map((c, i) => ({ c, i }))
    .sort((a, b) => {
      const da = score(a.c), db = score(b.c);
      return da !== db ? da - db : a.i - b.i;
    })
    .map(({ c }) => c);
};

  /** returns true then we display question else we don't */
  export function showQuestion(q, question){
    const qq = (q ?? "").trim().toLowerCase();
    if(!qq || qq.length==0) return true;
    const heading = ""+question.questionId+". "+(question?.heading ?? "") +
    " "+ (question?.designPatterns ?? "")
    return (heading.toLowerCase().includes(qq) || 
                ((question?.companies ?? []).some(
                (c) =>
                    (c?.name ?? "").toLowerCase().includes(qq) ||
                    (c?.code ?? "").toLowerCase().includes(qq)
                ))
        );
  }
